export default "/images/42d5b53b86d58e77e6a71348aecde382.avif";